import { TrendingUp } from '@mui/icons-material';
import { Avatar, CardContainer, Button, DataTable, Tag } from 'finara-components';
import type { DataTableColumn, TagVariant } from 'finara-components';

import { Transaction } from '@/data/admin/dashboard/dashboardData';

interface RecentTransactionsProps {
  transactions: Transaction[];
  onViewAll?: () => void;
}

const getStatusVariant = (status: Transaction['status']): TagVariant => {
  switch (status) {
    case 'Completado':
      return 'green';
    case 'Procesando':
      return 'blue';
    case 'Pendiente':
      return 'yellow';
    default:
      return 'gray';
  }
};

export const RecentTransactions: React.FC<RecentTransactionsProps> = ({
  transactions,
  onViewAll,
}) => {
  const columns: DataTableColumn<Transaction>[] = [
    {
      key: 'employee',
      label: 'Empleado',
      width: '35%',
      render: (_, row) => (
        <Avatar
          initials={row.initials}
          title={row.employeeName}
          subtitle={row.employeeId}
          size="large"
          avatarTextColor="text-brand-white"
        />
      ),
    },
    {
      key: 'type',
      label: 'Tipo',
      width: '25%',
      accessor: 'type',
    },
    {
      key: 'amount',
      label: 'Monto',
      width: '20%',
      render: (_, row) => <span className="font-medium">${row.amount.toLocaleString()}</span>,
    },
    {
      key: 'status',
      label: 'Estado',
      width: '15%',
      render: (_, row) => <Tag variant={getStatusVariant(row.status)}>{row.status}</Tag>,
    },
  ];

  return (
    <CardContainer className="h-full">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <TrendingUp className="text-brand-blue" fontSize="small" />
          <h3 className="text-sm font-semibold text-brand-white">Transacciones Recientes</h3>
        </div>
        <Button variant="white" size="small" onClick={onViewAll}>
          Ver historial completo
        </Button>
      </div>

      <p className="text-[12.5px] text-muted mb-6">Últimas operaciones de tu empresa</p>

      {/* DataTable */}
      <div className="w-full overflow-scroll">
        <DataTable
          columns={columns}
          data={transactions}
          onRowClick={_row => {
            // Handle transaction row click
          }}
        />
      </div>
    </CardContainer>
  );
};
